import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const container: CSSObject = {
  display: 'flex',
  blockSize: '100%',
  paddingInline: Spacing.S,
}

export const left: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
}

export const center: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
}

export const right: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-end',

  '& > *': {
    marginInlineStart: Spacing.S,
  },
}
